import { defineComponent as _defineComponent } from 'vue';
import { computed, defineAsyncComponent } from 'vue';
import store from '@/store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GlobalReservationsDialogs',
    setup(__props) {
        const CreateReservationDialog = defineAsyncComponent(() => import('@/components/reservations/create-reservation-form/CreateReservationDialog.vue'));
        const ReservationDialog = defineAsyncComponent(() => import('@/components/reservations/ReservationDialog.vue'));
        const EditReservationItemDialog = defineAsyncComponent(() => import('@/components/reservations/EditReservationItemDialog.vue'));
        const CancelItemDialog = defineAsyncComponent(() => import('@/components/reservations/CancelItemDialog.vue'));
        const ReservationItemCheckInResultDialog = defineAsyncComponent(() => import('@/components/reservations/ReservationItemCheckInResultDialog.vue'));
        const createDialogIsOpen = computed(() => store.state.reservation.createDialog.isOpen);
        const createDialogInitialItems = computed(() => {
            const prefill = store.state.reservation.createDialog.prefill;
            if (!prefill) {
                return undefined;
            }
            return prefill.items.map(item => ({
                cart_item_id: crypto.randomUUID(),
                reservable_product_id: item.reservable_product_id,
                preferred_reservable_ids: item.preferred_reservable_ids,
                quantity: item.quantity ?? 1000,
                delivery_date_time: item.delivery_date_time,
                return_date_time: item.return_date_time,
                price: item.price_per_step ?? 0,
                price_mode: 'catalog',
                note: null,
                has_custom_time: false
            }));
        });
        const reservationDetailsDialogIsOpen = computed(() => store.state.reservation.reservationDetailsDialog.isOpen);
        const reservationDetailsDialogData = computed(() => undefined);
        const reservationDetailsDialogLoading = computed(() => undefined);
        const editItemDialogIsOpen = computed(() => store.state.reservation.editItemDialog.isOpen);
        const editItemDialogItem = computed(() => store.state.reservation.editItemDialog.item);
        const cancelItemDialogIsOpen = computed(() => store.state.reservation.cancelItemDialog.isOpen);
        const cancelItemDialogItem = computed(() => store.state.reservation.cancelItemDialog.item);
        const checkInResultDialogIsOpen = computed(() => store.state.reservation.checkInResultDialog.isOpen);
        const checkInResultDialogItem = computed(() => store.state.reservation.checkInResultDialog.item);
        const handleCreateDialogInput = (isOpen) => {
            if (!isOpen) {
                store.dispatch('reservation/closeCreateDialog');
            }
        };
        const handleReservationSaved = () => {
            store.dispatch('reservation/closeCreateDialog');
        };
        const handleReservationDetailsDialogInput = (isOpen) => {
            if (!isOpen) {
                store.dispatch('reservation/closeDialog');
            }
        };
        const handleEditDialogInput = (isOpen) => {
            if (!isOpen) {
                store.dispatch('reservation/closeEditItemDialog');
            }
        };
        const handleCancelDialogInput = (isOpen) => {
            if (!isOpen) {
                store.dispatch('reservation/closeCancelItemDialog');
            }
        };
        const handleItemCancelled = () => {
            store.dispatch('reservation/closeCancelItemDialog');
        };
        const handleCheckInResultDialogInput = (isOpen) => {
            if (!isOpen) {
                store.dispatch('reservation/closeCheckInResultDialog');
            }
        };
        return { __sfc: true, CreateReservationDialog, ReservationDialog, EditReservationItemDialog, CancelItemDialog, ReservationItemCheckInResultDialog, createDialogIsOpen, createDialogInitialItems, reservationDetailsDialogIsOpen, reservationDetailsDialogData, reservationDetailsDialogLoading, editItemDialogIsOpen, editItemDialogItem, cancelItemDialogIsOpen, cancelItemDialogItem, checkInResultDialogIsOpen, checkInResultDialogItem, handleCreateDialogInput, handleReservationSaved, handleReservationDetailsDialogInput, handleEditDialogInput, handleCancelDialogInput, handleItemCancelled, handleCheckInResultDialogInput };
    }
});
